"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivateEmailLoginCheckAccountRequestPayloadToJSON = exports.ActivateEmailLoginCheckAccountRequestPayloadFromJSONTyped = exports.ActivateEmailLoginCheckAccountRequestPayloadFromJSON = void 0;
function ActivateEmailLoginCheckAccountRequestPayloadFromJSON(json) {
    return ActivateEmailLoginCheckAccountRequestPayloadFromJSONTyped(json, false);
}
exports.ActivateEmailLoginCheckAccountRequestPayloadFromJSON = ActivateEmailLoginCheckAccountRequestPayloadFromJSON;
function ActivateEmailLoginCheckAccountRequestPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'customerNo': json['customerNo'],
        'dateOfBirth': (new Date(json['dateOfBirth'])),
    };
}
exports.ActivateEmailLoginCheckAccountRequestPayloadFromJSONTyped = ActivateEmailLoginCheckAccountRequestPayloadFromJSONTyped;
function ActivateEmailLoginCheckAccountRequestPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'customerNo': value.customerNo,
        'dateOfBirth': (value.dateOfBirth.toISOString().substr(0, 10)),
    };
}
exports.ActivateEmailLoginCheckAccountRequestPayloadToJSON = ActivateEmailLoginCheckAccountRequestPayloadToJSON;
//# sourceMappingURL=ActivateEmailLoginCheckAccountRequestPayload.js.map